module.exports = __webpack_public_path__ + "img/icon_unselected_xiaoxiongmao.ebd48ad5.png";